import { stringToSVG } from '../../../utilities';

const svg = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1667_104)">
<path d="M27.5 5V10H32.5" stroke="black" stroke-width="1.5"/>
<path d="M32.5 10L27.5 5H7.5V35H32.5V10Z" stroke="#2E3138" stroke-width="1.5"/>
<path d="M12.5 12.5H17.5" stroke="#2E3138" stroke-width="1.5"/>
<path d="M12.5 17.5H27.5" stroke="#2E3138" stroke-width="1.5"/>
<path d="M22.5 22.5H12.5" stroke="#2E3138" stroke-width="1.5"/>
<path d="M12.5 27.5H27.5" stroke="#2E3138" stroke-width="1.5"/>
</g>
<defs>
<clipPath id="clip0_1667_104">
<rect width="40" height="40" fill="white"/>
</clipPath>
</defs>
</svg>`;

export default stringToSVG(svg);